module.exports = __webpack_public_path__ + "static/media/user.85cd4da4.png";